import React from 'react';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";

const Tile = _ref => {
  let {
    isLastChild = false,
    children,
    asOuter,
    asInner,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    as: asOuter,
    sx: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: ['smoke', 'smoke', 'transparent', 'transparent'],
      borderRightWidth: isLastChild ? 'none' : ['0px', '0px', '1px '],
      borderRightStyle: isLastChild ? 'none' : 'solid',
      borderRightColor: isLastChild ? 'transparent' : ['transparent', 'transparent', 'ghost', 'ghost'],
      ['@media screen and (max-width: 310px)']: {
        fontSize: 'font-sm'
      },
      ['@media screen and (max-width: 280px)']: {
        letterSpacing: '-0.5px'
      }
    },
    onClick: onClick,
    buttonVariant: "tile",
    "data-id": "tile-list_tile_Tile_Box",
    children: /*#__PURE__*/_jsx(Stack, {
      align: "center",
      justify: "center",
      sx: {
        paddingY: 'spacing-md',
        minWidth: '132px'
      },
      as: asInner,
      "data-id": "tile-list_tile_Tile_Box_Stack",
      children: children
    })
  });
};

export default Tile;